import { ActivityDetail, ActivityId, ActivityWithProgramCount } from './types'
import { ApiResponse } from '../../types'
import client from '../../client'

export * from './types'

export const list = async () => {
  const { data }: ApiResponse<ActivityWithProgramCount[]> = await client.get(
    '/user/activities'
  )
  return data
}

export const get = async (id: ActivityId) => {
  const data: ActivityDetail = await client.get(`/user/activities/${id}`)
  return data
}
